import { render, staticRenderFns } from "./Spirit.vue?vue&type=template&id=77f7173f&scoped=true"
import script from "./Spirit.vue?vue&type=script&lang=js"
export * from "./Spirit.vue?vue&type=script&lang=js"
import style0 from "./Spirit.vue?vue&type=style&index=0&id=77f7173f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7173f",
  null
  
)

export default component.exports